// extracted by mini-css-extract-plugin
module.exports = {"container":"TrustBoxes_container__rA35g","heading":"TrustBoxes_heading__QmB02","boxes_container":"TrustBoxes_boxes_container__c5GlL","divider":"TrustBoxes_divider__mcwFO"};